import { render, staticRenderFns } from "./consultantPortrait.vue?vue&type=template&id=7130bf8d&scoped=true"
import script from "./consultantPortrait.vue?vue&type=script&lang=js"
export * from "./consultantPortrait.vue?vue&type=script&lang=js"
import style0 from "./consultantPortrait.vue?vue&type=style&index=0&id=7130bf8d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7130bf8d",
  null
  
)

export default component.exports